module.exports = __webpack_public_path__ + "img/5.beee79f2.svg";